export enum PushNotificationType {
    DEFAULT = 'DEFAULT',
    ARTICLE = 'ARTICLE',
    CATEGORY = 'CATEGORY'
}
